import React, { useState, useContext } from 'react';
import Enrollment from '../models/Enrollment'
import { Items } from '@thinkwell/react.common'
import { UserContext } from './User'

const EnrollmentsContext = React.createContext([{}, () => {}, () => {}, () => {}, () => {}]);

const EnrollmentsProvider = (props) => {
  const user = useContext(UserContext);

  const enrollments = props.value.map((s) => Enrollment(s))
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(enrollments))

  const upsertEnrollment = (response) => {
    if (response.to && response.from) {
      upsertItem([
        Enrollment(response.to),
        Enrollment(response.from)
      ])
    } else if (response.to) {
      upsertItem(Enrollment(response.to), response.replace)
    } else {
      // add subscription from admin UI
      upsertItem(Enrollment(response))
    }
  }

  return (
    <EnrollmentsContext.Provider value={[items, setItems, upsertEnrollment, getItem, deleteItem]}>
      {props.children}
    </EnrollmentsContext.Provider>
  );
};

export { EnrollmentsContext, EnrollmentsProvider}
